import React from 'react';

import { Avatar, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';

type ClientInformationType = {
  fullName: string;
  email: string;
};

const ClientInformation = ({ fullName, email }: ClientInformationType) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        CLIENT INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Client Name : </Typography>

          <div className="profile">
            <Typography className="value">{fullName}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Email Address :</Typography>

          <Typography className="value">{email}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default ClientInformation;
